import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const PaymentEuro: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m231.71 565.07-7.03 15.55h-94.96l5.75-15.55zm-13.57 29.76-7.74 15.91h-80.68l5.75-15.91zm32.03-68.61-11.36 24.29c-1.89-1.32-4.18-2.78-6.85-4.37s-5.73-2.94-9.16-4.05-7.23-1.67-11.4-1.67c-6.58 0-12.31 1.66-17.19 4.97s-8.65 8.48-11.33 15.48c-2.68 7.01-4.01 16-4.01 26.99s1.34 20.09 4.01 27.02c2.67 6.94 6.45 12.03 11.33 15.27s10.61 4.87 17.19 4.87c4.17 0 7.95-.54 11.36-1.63s6.4-2.39 8.98-3.91c2.58-1.51 4.75-2.91 6.5-4.19l11.5 24.29c-5.16 4.26-11.01 7.47-17.54 9.62s-13.47 3.23-20.81 3.23c-12.41 0-23.38-2.95-32.92-8.84-9.54-5.9-17.01-14.39-22.41-25.5s-8.1-24.51-8.1-40.23 2.7-29.1 8.1-40.27 12.87-19.73 22.41-25.67 20.51-8.91 32.92-8.91c7.62 0 14.68 1.14 21.16 3.41 6.49 2.27 12.36 5.54 17.61 9.8z' />
    <path d='m600 660.16h-250v-30h220v-345h30z' />
    <path d='m210 480h-30v-359.83h255v29.99h-225z' />
    <path d='m585 300.16h-150c-8.28 0-15-6.72-15-15v-150c0-6.07 3.65-11.54 9.26-13.86 5.6-2.32 12.06-1.04 16.35 3.25l150 150c4.29 4.29 5.57 10.74 3.25 16.35-2.32 5.6-7.79 9.26-13.86 9.26zm-135-30h98.79l-98.79-98.79z' />
    <path d='m270.08 660.16h224.92s0-30 0-30h-194.92c-16.57 0-30 13.43-30 30z' />
  </IconBase>
));

PaymentEuro.displayName = 'PaymentEuro';

export default PaymentEuro;
